import { render, staticRenderFns } from "./FreelancerInvitation.vue?vue&type=template&id=7bdb2248"
import script from "./FreelancerInvitation.vue?vue&type=script&lang=ts"
export * from "./FreelancerInvitation.vue?vue&type=script&lang=ts"
import style0 from "./FreelancerInvitation.vue?vue&type=style&index=0&id=7bdb2248&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports